import React, { useState, useEffect, useRef } from 'react';
import { FaUserAlt, FaChevronDown, FaChevronUp, FaBars, FaTimes, FaShoppingCart, FaShoppingBag, FaSignOutAlt,FaUser } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../store/UserContext';
import { collection, getDocs, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/Config';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const { currentUser, userData, logout } = useUser();
  const [cartCount, setCartCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);

const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
        setIsDropdownOpen(false);
    }
};

const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
};

  useEffect(() => {
    if (currentUser) {
      const cartRef = collection(db, 'cart');
      const q = query(cartRef, where('userId', '==', currentUser.uid));
      
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        setCartCount(querySnapshot.size);
      }, (error) => {
        console.error('Error listening to cart changes:', error);
      });

      return () => unsubscribe();
    } else {
      setCartCount(0);
    }
  }, [currentUser]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
      setIsDropdownOpen(false);
      setIsOpen(false);
    } catch(error) {
      console.error('Error logging out:', error);
    }
  };

  

  const navigateTo = (path) => {
    navigate(path);
    setIsOpen(false);
    setIsDropdownOpen(false);
  };

  return (
    <header className="fixed w-full bg-black shadow-xl font-sans z-50">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
       
        <div className="flex items-center">
          <a 
            href="#" 
            className="text-2xl md:text-3xl font-extrabold text-white hover:text-yellow-300 transition-colors duration-300 "
            onClick={(e) => { e.preventDefault(); navigateTo('/'); }}
          >
            Fashion Loop<span className="text-yellow-300">.In <sup className="text-xs">®</sup></span>
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6 lg:space-x-8 items-center">
          <a 
            href="#" 
            className="hover:no-underline text-white hover:text-yellow-300 text-base lg:text-lg font-medium transition-colors duration-300 relative group"
            onClick={(e) => { e.preventDefault(); navigateTo('/'); }}
          >
            Products
            <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
          </a>

          <a 
            href="#" 
            className="hover:no-underline flex items-center text-white hover:text-yellow-300 text-base lg:text-lg font-medium transition-colors duration-300 relative group"
            onClick={(e) => { e.preventDefault(); navigateTo('/cart'); }}
          >
            <FaShoppingCart className="mr-1" />
            Cart 
            {cartCount > 0 && (
              <span className="ml-1 bg-yellow-300 text-indigo-700 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold">
                {cartCount}
              </span>
            )}
            <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
          </a>

          {currentUser && (
            <a 
              href="#" 
              className="hover:no-underline text-white hover:text-yellow-300 text-base lg:text-lg font-medium transition-colors duration-300 relative group"
              onClick={(e) => { e.preventDefault(); navigateTo('/orders'); }}
            >
              Orders
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
            </a>
          )}

          {currentUser && (
            <a 
              href="#" 
              className="hover:no-underline text-white hover:text-yellow-300 text-base lg:text-lg font-medium transition-colors duration-300 relative group"
              onClick={(e) => { e.preventDefault(); navigateTo('/contact-us'); }}
            >
              Contact Us
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
            </a>
          )}

          {!currentUser && (
            <a 
              href="#" 
              className="hover:no-underline text-white hover:text-yellow-300 text-base lg:text-lg font-medium transition-colors duration-300 relative group"
              onClick={(e) => { e.preventDefault(); navigateTo('/login'); }}
            >
              Login
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
            </a>
          )}
          
          <div className="relative group ml-4" ref={dropdownRef}>
                        <button
                            onClick={toggleDropdown}
                            className="flex items-center text-white hover:text-yellow-300 text-base lg:text-lg font-medium transition-colors duration-300 focus:outline-none"
                        >
                            <FaUser className="mr-2" />
                            {currentUser?.displayName || 'Account'}
                            <span className="ml-2 transform transition-transform duration-200">
                                {isDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
                            </span>
                        </button>
                        
                        {isDropdownOpen && (
              <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-xl py-2 ring-1 ring-black ring-opacity-5 z-50 animate-fade-in">
                {currentUser && (
                  <a 
                    href="#" 
                    className="block px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200"
                    onClick={(e) => { e.preventDefault(); navigateTo('/orders'); }}
                  >
                    Order History
                  </a>
                )}  
                {currentUser && userData?.isAdmin && (
                  <a 
                    href="#" 
                    className="block px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200"
                    onClick={(e) => {; navigateTo('/admin-home'); }}
                  >
                    Admin Panel
                  </a>
                )}  
                {currentUser && (
                  <a 
                    href="#" 
                    className="block px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200"
                    onClick={(e) => { e.preventDefault(); handleLogout(); }}
                  >
                    Logout
                  </a>
                )}               
                {!currentUser && (
                  <>
                    <a 
                      href="#" 
                      className="block px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200"
                      onClick={(e) => { e.preventDefault(); navigateTo('/login'); }}
                    >
                      Login
                    </a>
                    <a 
                      href="#" 
                      className="block px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200"
                      onClick={(e) => { e.preventDefault(); navigateTo('/signup'); }}
                    >
                      Signup
                    </a>
                  </>
                )}
              </div>
            )}
                    </div>

          
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center">
          <div className="relative mr-4">
            <a 
              href="#" 
              className="text-white hover:text-yellow-300"
              onClick={(e) => { e.preventDefault(); navigateTo('/cart'); }}
            >
              <FaShoppingCart className="text-xl" />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-yellow-300 text-indigo-700 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold">
                  {cartCount}
                </span>
              )}
            </a>
          </div>
          
          <button
            onClick={toggleMenu}
            className="text-white hover:text-yellow-300 focus:outline-none p-2 rounded-md transition-colors duration-300"
            aria-label="Toggle menu"
          >
            {isOpen ? <FaTimes className="text-xl" /> : <FaBars className="text-xl" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <nav className="md:hidden bg-indigo-700 border-t border-indigo-500 py-3 animate-slide-down">
          <div className="flex flex-col items-center space-y-3 px-4">
            <a 
              href="#" 
              className="w-full text-center py-2 text-white hover:text-yellow-300 font-medium rounded-md transition-colors duration-300"
              onClick={(e) => { e.preventDefault(); navigateTo('/'); }}
            >
              Products
            </a>
            
            <a 
              href="#" 
              className="w-full text-center py-2 text-white hover:text-yellow-300 font-medium rounded-md transition-colors duration-300"
              onClick={(e) => { e.preventDefault(); navigateTo('/cart'); }}
            >
              <span className="flex items-center justify-center">
                Cart 
                {cartCount > 0 && (
                  <span className="ml-2 bg-yellow-300 text-indigo-700 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold">
                    {cartCount}
                  </span>
                )}
              </span>
            </a>
            
            {currentUser && (
              <a 
                href="#" 
                className="w-full text-center py-2 text-white hover:text-yellow-300 font-medium rounded-md transition-colors duration-300"
                onClick={(e) => { e.preventDefault(); navigateTo('/orders'); }}
              >
                Orders
              </a>
            )}
            
            {currentUser && (
              <a 
                href="#" 
                className="w-full text-center py-2 text-white hover:text-yellow-300 font-medium rounded-md transition-colors duration-300"
                onClick={(e) => { e.preventDefault(); navigateTo('/contact-us'); }}
              >
                Contact Us
              </a>
            )}
             {currentUser && (
                    <a 
                      href="#" 
                      className="block px-4 py-2 text-white hover:bg-indigo-500 transition-colors duration-200"
                      onClick={(e) => { e.preventDefault(); navigateTo('/orders'); }}
                    >
                      Order History
                    </a>
                  )}  
                  
                  {currentUser && userData?.isAdmin && (
                    <a 
                      href="#" 
                      className="block px-4 py-2 text-white hover:bg-indigo-500 transition-colors duration-200"
                      onClick={(e) => { e.preventDefault(); navigateTo('/admin-home'); }}
                    >
                      Admin Panel
                    </a>
                  )}  
                  
                  {currentUser && (
                    <a 
                      href="#" 
                      className="block px-4 py-2 text-white hover:bg-indigo-500 transition-colors duration-200"
                      onClick={(e) => { e.preventDefault(); handleLogout(); }}
                    >
                      Logout
                    </a>
                  )}               
                  
                  {!currentUser && (
                    <>
                      <a 
                        href="#" 
                        className="block px-4 py-2 text-white hover:bg-indigo-500 transition-colors duration-200"
                        onClick={(e) => { e.preventDefault(); navigateTo('/login'); }}
                      >
                        Login
                      </a>
                      <a 
                        href="#" 
                        className="block px-4 py-2 text-white hover:bg-indigo-500 transition-colors duration-200"
                        onClick={(e) => { e.preventDefault(); navigateTo('/signup'); }}
                      >
                        Signup
                      </a>
                    </>
                  )}
            
           
          </div>
        </nav>
      )}
    </header>
  );
};

// Reusable component for dropdown items
const DropdownItem = ({ icon, text, onClick }) => (
  <a 
      href="#" 
      className="flex items-center px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200"
      onClick={(e) => { e.preventDefault(); onClick(); }}
  >
      <span className="mr-2">{icon}</span>
      {text}
  </a>
);

// Reusable component for mobile nav it

export default Header;